<template>
  <div class="invoice_title_list">
    <van-swipe-cell
      v-for="(item, index) of list"
      :key="index"
      :before-close="beforeClose"
      :right-width="64"
      class="invoice_title_list_item">
      <van-cell :border="false" is-link :label="item.taxNumber" @click="routeToEdit(item.id)">
        <template #title>
          <div class="item_title">
            <span class="custom-title">{{item.title}}</span>
            <span v-if="item.defaultState==='1'" class="custom-tag">默认</span>
          </div>
        </template>
      </van-cell>
      <template #right>
        <van-button square type="danger" text="删除" @click.stop="deleteTitle(item.id)" />
      </template>
    </van-swipe-cell>
  </div>
</template>

<script>
  import { deleteInvoiceTitle } from '@/api/invoiceApi'
  export default {
    name: "invoiceTitleList",
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    methods: {
      // 删除
      beforeClose({ position, instance }) {
        switch (position) {
          case 'outside':
            instance.close();
            break;
          case 'right':
            this.$dialog.confirm({
              message: '确定删除吗？',
            }).then(() => {
              console.log(instance)
              instance.close()
            });
            break;
        }
      },
      // 跳转编辑
      routeToEdit(id) {
        this.$router.push({name: 'setInvoiceTitle', query: { id }})
      },
      // 删除抬头
      deleteTitle(id) {
        deleteInvoiceTitle(id).then(res => {
          if (res.status === 'OK') {
            this.$toast('删除成功')
            this.$emit('success')
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invoice_title_list {
    .invoice_title_list_item {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      /deep/.van-swipe-cell__wrapper {
        width: 100%;
        .van-cell {
          display: flex;
          align-items: center;
        }
      }
      .van-button {
        height: 100%;
        width: 64px;
      }
    }
  }
  .title {
    height: 22px;
    line-height: 22px;
  }
  .custom-title {
    font-size: 16px;
    vertical-align: middle;
    flex: 1;
    min-width: 0;
  }
  .item_title {
    display: flex;
  }
  .custom-tag {
    width: 36px;
    font-size: 12px;
    padding: 0 5px;
    border: 1px solid #FF8A49;
    color: #FF8A49;
    margin-left: 4px;
    vertical-align: middle;
    text-align: center;
    line-height: 25px;
    height: 25px;
  }
</style>
